import { render, staticRenderFns } from "./OldCountryDropdownField.vue?vue&type=template&id=0cb89214"
import script from "./OldCountryDropdownField.vue?vue&type=script&setup=true&lang=ts"
export * from "./OldCountryDropdownField.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cb89214')) {
      api.createRecord('0cb89214', component.options)
    } else {
      api.reload('0cb89214', component.options)
    }
    module.hot.accept("./OldCountryDropdownField.vue?vue&type=template&id=0cb89214", function () {
      api.rerender('0cb89214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/OldCountryDropdownField.vue"
export default component.exports